import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';

function* createTranslationFailureAsync({ error }) {
    yield put(showNotification(error.response.message, 'warning'));
}

function* createTranslationSuccessAsync() {
    yield put(showNotification('notifications.utilities.translate.create.success', 'success'));
}

export default function* dashboardSagas() {
    yield [
        takeEvery('CREATE_TRANSLATION_FAILURE', createTranslationFailureAsync),
        takeEvery('CREATE_TRANSLATION_SUCCESS', createTranslationSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/utilities/translateSagas.js